var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBigLief2 = function SvgBigLief2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 119,
    viewBox: "0 0 80 119",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9859 38.7466C41.8747 37.668 45.1472 28.5979 43.2954 18.4881C41.4435 8.37829 35.1685 1.0571 29.2798 2.13577C23.391 3.21444 20.1184 12.2845 21.9703 22.3943C23.8221 32.5041 30.0971 39.8253 35.9859 38.7466Z",
    fill: "#5BBEAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3826 78.0709C73.7735 70.9286 76.3924 61.6487 72.2322 57.3436C68.0719 53.0385 58.7079 55.3385 51.317 62.4808C43.9261 69.6231 41.3071 78.903 45.4674 83.2081C49.6276 87.5132 58.9917 85.2131 66.3826 78.0709Z",
    fill: "#5BBEAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8577 41.2454C64.4787 34.9706 65.2616 27.7015 61.6062 25.0094C57.9507 22.3173 51.2412 25.2217 46.6201 31.4965C41.999 37.7712 41.2163 45.0403 44.8717 47.7323C48.5272 50.4244 55.2366 47.5201 59.8577 41.2454Z",
    fill: "#5BBEAA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1001 33.87C34.1001 37.55 38.5002 49.33 34.6502 54.04C30.8002 58.75 21.3402 57.17 13.3802 50.66C5.77017 44.45 5.75012 34.42 5.83012 30.5C5.83012 29.41 7.98017 28.38 15.5102 29.8C25.9402 31.78 25.7601 33.17 27.1001 33.87Z",
    fill: "#5BBEAA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1697 82.3605C39.9575 77.7244 36.576 68.6943 28.6168 62.1913C20.6576 55.6884 11.1346 54.1751 7.34679 58.8112C3.55893 63.4473 6.94051 72.4773 14.8997 78.9802C22.859 85.4832 32.3818 86.9966 36.1697 82.3605Z",
    fill: "#5BBEAA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6099 15.9399C36.0099 32.4699 38.6099 41.3099 40.7999 65.5099C41.2199 89.3499 41.4098 100.44 41.7098 117.91",
    stroke: "#024B85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.27 38.0402L39.39 52.3202L53.7 33.9902",
    stroke: "#024B85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0601 70.2002L41.16 85.9102L57.1801 71.1802",
    stroke: "#024B85",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBigLief2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bigLief2.21334fe1.svg";
export { ForwardRef as ReactComponent };